
export const ROOT_PATH_APP = '/putno-osiguranje';

export const AppRoutes = {
  ROOT: `${ROOT_PATH_APP}`,
  TERMS_AND_CONDITIONS: `${ROOT_PATH_APP}/uvjeti-poslovanja`,

  WEBSHOP: {
    STEP_1: `${ROOT_PATH_APP}/osiguranje`,
    STEP_2: `${ROOT_PATH_APP}/putnici`,
    STEP_3: `${ROOT_PATH_APP}/ponude`,
    STEP_4: `${ROOT_PATH_APP}/ponuda`,
    CHECKOUT: `${ROOT_PATH_APP}/placanje`,
    CHECKOUT_SUCCESS: `${ROOT_PATH_APP}/placanje-uspjeh`,
    CHECKOUT_FAILURE: `${ROOT_PATH_APP}/placanje-neuspjeh`,
    CHECKOUT_SUCCESS_OFFLINE: `${ROOT_PATH_APP}/placanje-uspjeh-o`
  }
}

export const RouteStepMapper = {
  STEP_1: 'osiguranje',
  STEP_2: 'putnici',
  STEP_3: 'ponude'
}

export type RouteStep = keyof typeof RouteStepMapper;

export const RoutePath = (step: RouteStep) => {
  return `${ROOT_PATH_APP}/${RouteStepMapper[step]}`;
};
